/* global process */

export default {
  audience: process.env.REACT_APP_AUTH0_AUDIENCE,
  client_id: process.env.REACT_APP_AUTH0_CLIENT_ID,
  domain: process.env.REACT_APP_AUTH0_DOMAIN,
  redirect_uri: window.location.origin,
};
